import React from 'react'

function Operations ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 24 24'>
      <path d='M20.571,44.189H2.286A2.292,2.292,0,0,1,0,41.9V23.618a2.293,2.293,0,0,1,2.286-2.286H13.714v1.143H2.286a1.146,1.146,0,0,0-1.143,1.143V41.9a1.146,1.146,0,0,0,1.143,1.143H20.571A1.146,1.146,0,0,0,21.714,41.9V30.475h1.143V41.9A2.293,2.293,0,0,1,20.571,44.189Zm0,0' transform='translate(0 -20.189)' />
      <path d='M302.668,8a4,4,0,1,1,4-4A4,4,0,0,1,302.668,8Zm0-6.857A2.857,2.857,0,1,0,305.525,4,2.856,2.856,0,0,0,302.668,1.143Zm0,0' transform='translate(-282.668)' />
      <path d='M64,160H74.286v1.143H64Zm0,0' transform='translate(-60.571 -151.429)' />
      <path d='M64,288H80v1.143H64Zm0,0' transform='translate(-60.571 -272.571)' />
    </svg>
  )
}

Operations.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Operations
